// import black from 'src/shared/assets/images/black.png';
import orange from 'src/shared/assets/images/2024/hero_2.png';
import pink from 'src/shared/assets/images/2024/hero_1.png';
import yellow from 'src/shared/assets/images/2024/hero_3.png';
import { classNames } from 'src/shared/lib/helpers/classNames';
import cls from './CharactersCover.module.scss';

export const CharactersCover = () => (
  <>
    {/* <img */}
    {/*   className={classNames(cls.black, {}, [cls.img])} */}
    {/*   src={black} */}
    {/*   alt='black' */}
    {/* /> */}
    <img
      className={classNames(cls.orange, {}, [cls.img])}
      src={orange}
      alt='orange'
    />
    <img
      className={classNames(cls.pink, {}, [cls.img])}
      src={pink}
      alt='pink'
    />
    <img
      className={classNames(cls.yellow, {}, [cls.img])}
      src={yellow}
      alt='yellow'
    />
  </>
);
